<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content hide-scroll">
                <div class="bg-white w-full rounded-25 relative" v-if="serialModel != null">
                    <div class="absolute top-18px right-9 z-10">
                        <img class="w-18px" src="../../../../assets/close/close.png" @click="clickClose()">
                    </div>
                    <SerialDetail :serialModel="serialModel"></SerialDetail>
                    <Serial :serialModel="serialModel" ref="serial" @useSerial="useSerial"></Serial>
                    <!-- <PrivilegeMessage :serialModel="serialModel"></PrivilegeMessage> -->
                    <SerialTimer :serialModel="serialModel" @onSerialExpired="onSerialExpired()"></SerialTimer>
                    <div class="px-9 mt-5" v-if="!hideBtnPrivilage">
                        <OutlineBlueBtn class="text-20" paddingClass="py-1" @click="goHistory()">{{lbl.detail.success_modal.my_reward}}</OutlineBlueBtn>
                        <BlueBtn class="w-full text-20" paddingClass="py-1 mt-4" @click="goCampaignList()">{{lbl.detail.success_modal.more_reward}}</BlueBtn>
                    </div>
                    <div class="pt-4 pb-5">
                        <!-- <img class="bzbs-logo m-auto" src="../../../../assets/logo/buzzebees-logo-dark.svg"> -->
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import SerialDetail from "./component/SerialDetail.vue";
import Serial from "./component/Serial.vue";
// import PrivilegeMessage from "./component/PrivilegeMessage.vue";
import SerialTimer from "./component/SerialTimer.vue";
import OutlineBlueBtn from "@/components/Button/OutlineBlueBtn.vue";
import BlueBtn from "@/components/Button/BlueBtn.vue";

export default {
    name: "SerialModal",
    mixins: [LocaleMixin],
    components: {
        SerialDetail,
        Serial,
        // PrivilegeMessage,
        SerialTimer,
        OutlineBlueBtn,
        BlueBtn,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            serialModel: null,
            hideBtnPrivilage: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function (config) {
            this.$nextTick(() => {
                this.serialModel = config.serialModel;
                this.hideBtnPrivilage = config.hideBtn;
                document.body.classList.add('not-scroll');
                this.open = true;
            });
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function() {
            console.log('click close');
            this.hide();
            this.controller.sendCloseModal();
        },

        getRedeemMessage: function () {
            let dateStr = DatetimeHelper.getDatetimeFullFormat(this.serialModel.redeemTimestamp);
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },

        onSerialExpired: function() {
            this.$refs['serial'].setSerialExpire();
            this.controller.sendSerialExpire();
        },

        goHistory: function() {
            this.$router.push('/history/redeem?tab=redeem');
        },
        goCampaignList: function() {
            this.$router.push('/privilege');
        },
        useSerial: function() {  
            this.controller.sendUseSerial();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            padding-top: 100px;
            padding-bottom: 40px;
            overflow: auto;
            width: 380px;

            @include mobile {
                width: 100%;
                padding: 16px {
                    top: 100px;
                };
            }
        }
    }

    .bzbs-logo {
        width: 70px;
    }
</style>
